module.exports = __webpack_public_path__ + "static/media/payment-mastercard.318791a5.png";